<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		ok-title="Asignar"
		title="Asignar categoria de servicio"
		static
		id="modal-assign-category-view"
		size="md"
		body-class="position-static"
		@ok="showConfirm"
		>
		<b-row>
			<div class="col-12">
				<p class="mb-0">{{rowsMessage}}</p>
			</div>
			<b-form-group class="col-12" label="Categoria de servicio">
				<b-form-select size="sm" v-model="serviceTypeCategory" :options="serviceTypesCategoriesOpts" required />
			</b-form-group>
		</b-row>
		<b-overlay :show="loadingConfirmation" no-wrap></b-overlay>
		<b-overlay :show="showConfirmation" no-wrap>
			<template #overlay>
				<b-overlay :show="loadingConfirmation"></b-overlay>
				<div v-if="!loadingConfirmation" style="min-width: 330px">
					<div class="text-center mb-4">
						<h4 id="form-confirm-label">¿Desea continuar?</h4>
					</div>
					<span v-html="confirmMessage"></span>
					<div class="text-center mt-4">
						<b-button
							variant="outline-danger"
							class="mr-3"
							@click="
								() => {
									showConfirmation = false;
								}
							"
							>Cancelar</b-button
						>
						<b-button variant="outline-success" @click="onSubmit"
							>Confirmar</b-button
						>
					</div>
				</div>
			</template>
		</b-overlay>
	</b-modal>
</template>

<script>
import api from '../../../api.js'

export default {
	methods: {
		onSubmit() {
			let aux = {
				ids: this.selected,
				serviceTypeCategoryId : this.serviceTypeCategory
			}
			this.loadingConfirmation = true
			api(this).post(`/transport-services/massive-update-service-categories`, aux ).then(() => {
				this.$root.showAlert('Actualización exitosa');
				this.$root.$emit('bv::refresh::table', 'reservations-index-list');
				this.$emit('update:selected',[])
				this.showConfirmation = false
				this.$bvModal.hide('modal-assign-category-view')
			}).catch(err => {
				this.$root.handleRequestError(err)
			}).finally(() => {
				this.loadingConfirmation = false
			});
		},
		showConfirm(event){
			event.preventDefault();
			if (this.serviceTypeCategory == '') {
				this.$root.showAlert('No hay categoria seleccionada',{ variant:'warning' })
				return;
			}
			if (!this.selected.length) {
				this.$root.showAlert('No hay registros seleccionados',{ variant:'warning' })
				return;
			}
			this.showConfirmation = true
		}
	},
	props: {
		selected: {
			type : Array,
			required: true
		},
	},
	components: {  },
	data(){
		return {
			serviceTypeCategory:'',
			showConfirmation: false,
			loadingConfirmation: false
		}
	},
	computed:{
		serviceTypesCategoriesOpts(){
			return this.$root.auxVars.serviceTypesCategoriesOpts
		},
		categorySelected() {
			return this.serviceTypesCategoriesOpts.find(({value}) => value === this.serviceTypeCategory)?.text
		},
		rowsMessage(){ return 'Ha seleccionado '+this.selected.length+' registros para actualizar.' },
		confirmMessage(){ return `Esta seguro de cambiar la categoria del servicio de ${this.selected.length} registros a <b>${this.categorySelected}</b>?` },
	},
	mounted(){
	},
	watch:{
	}
}
</script>
